import { Injectable } from '@angular/core';
import { Subject } from "rxjs/Subject";
import { SlideNotifier } from '../models/slideNotifier.model';

@Injectable()
export class NotificationService {
    private slideShowNotifier = new Subject<any>();
    private changeSlide = new Subject<SlideNotifier>();
    /**
     * Observable string streams
     */
    BodyNotifyObservable$ = this.slideShowNotifier.asObservable();
    SlideNotifyObservable$ = this.changeSlide.asObservable();

    constructor() { }

    public notifyBody(data: any) {
        this.slideShowNotifier.next(data);
    }

    public notifySlide(data: SlideNotifier){
        this.changeSlide.next(data);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/notification.service.ts